import PCLNAnalytics from '@pcln/analytics'
import { logEvent } from './logGaEvent'

//On details page, trigger event if bags api returns an error in bags call: “Unable to add additional bags at this time…. etc”:
export function logBagsRespFailed() {
  PCLNAnalytics.logEvent({
    category: 'mfly-details',
    action: 'Bags api call fails',
    label: 'Display',
  })
}

//   On details page, trigger event if user clicks “Continue to Checkout” before bags api call is able to be completed
export function logBagsCheckoutNotLoaded() {
  PCLNAnalytics.logEvent({
    category: 'mfly-details',
    action: 'User continues to Checkout before seeing bag call completed',
    label: 'Display',
  })
}

//   On details page, trigger event if bags api returns a success
export function logBagsSucceeded() {
  PCLNAnalytics.logEvent({
    category: 'mfly-details',
    action: 'Bags api call succeeds',
    label: 'Display',
  })
}

//   On details page, trigger event if user clicks to add a checked bag
export function logCheckedBagAdded() {
  PCLNAnalytics.logEvent({
    category: 'mfly-details',
    action: 'User adds a checked bag',
    label: 'Display',
  })
}

// On details page, trigger event if user clicks to subtract a checked bag and there is a bag to be subtracted
export function logCheckedBagSubtracted() {
  PCLNAnalytics.logEvent({
    category: 'mfly-details',
    action: 'User subtracts a checked bag',
    label: 'Display',
  })
}

//   On details page, trigger event if user clicks  to add a carry-on bag
export function logCarryOnAdded() {
  PCLNAnalytics.logEvent({
    category: 'mfly-details',
    action: 'User adds a carry-on bag',
    label: 'Display',
  })
}

// On details page, trigger event if user clicks to add a carry-on bag and there is a bag to be subtracted
export function logCarryOnSubtracted() {
  PCLNAnalytics.logEvent({
    category: 'mfly-details',
    action: 'User subtracts a carry-on bag',
    label: 'Display',
  })
}

// On details page, trigger event if user interacts to add a checked bag
export function logCheckedBagsInteraction({ productName }) {
  logEvent('internal_element', {
    link_name: 'checked_bags',
    page_name: 'details',
    product_name: productName,
    type: 'air_bag',
  })
}

// On details page, trigger event if user interacts to add a carry-on bag
export function logCarryOnBagsInteraction({ productName }) {
  logEvent('internal_element', {
    link_name: 'carry-on_bags',
    page_name: 'details',
    product_name: productName,
    type: 'air_bag',
  })
}
